import { Link } from "react-router-dom";

const SearchProductCard = ({ item, setShowDropdown, tab }) => {
  const linkTo = tab === "foods"
    ? `/food-details/${item._id}`
    : tab === "kitchens"
      ? `/SellerProfile/${item._id}`
      : tab === "categories"
        ? `/Category/${item._id}`
        : "#";
  return (
    <Link to={linkTo} className="ownfood-product-card-link" onClick={() => setShowDropdown(false)}>

      <div className="ownfood-product-card">
        {/* Foods and categories both expose `image`; kitchens use `kitchenLogo`. */}
        <img
          src={
            (tab === "kitchens" ? item?.kitchenLogo : item?.image) ||
            "/Assets/Img/kitchen_default.png"
          }
          alt={item?.name || "Item"}
          className="ownfood-product-img"
          onError={(e) => { e.target.src = "/Assets/Img/kitchen_default.png"; }}
        />

        {/* Info Section */}
        <div className="ownfood-product-info">
          <p className="ownfood-product-title">{item?.name || "N/A"}</p>

          {/* Price only for food */}
          {tab === "foods" && (
            <div className="ownfood-price-area">
              <span className="ownfood-price">{(item?.price - (item?.discountType === "percentage" ? item?.price * (item?.discountValue / 100) : item?.discountValue))?.toFixed(0)}৳</span>
              {item.discountValue > 0 && (
                <span className="ownfood-old-price">{item?.price?.toFixed(0)}৳</span>
              )}
              {item?.discountValue > 0 && (
                <span className="ownfood-discount small">({item?.discountValue}{item?.discountType === "percentage" ? "%" : "TK"} OFF)</span>
              )}
            </div>
          )}

          {tab === "kitchens" && item?.address?.text && (
            <div className="text-muted small">
              <span className="">Address: {item?.address?.text}</span>
            </div>
          )}
        </div>
      </div>
    </Link>

  );
};

export default SearchProductCard;
